/* eslint-disable react-hooks/exhaustive-deps */
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    hasKnowledgeChatPermission,
    isDisplayEyeSlashIcon,
    permissionChangeShareRangeStatus,
    displayTagOfThumbAttach,
    handleSelectFilePdf
} from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import {
    generateDetatilTicketTitle,
    viewTicketKnowledgeDetail
} from '@/component/ticketList/handler/TicketHandler';
import { getTitle } from '@/component/ticketList/handler/TicketListHandler';

import { Badge,  Checkbox,  FormControl, FormControlLabel, FormGroup, IconButton,  Popover, Tooltip, Typography } from '@material-ui/core';

import { I18n } from 'aws-amplify';

import {  getLinkDownloadFileFromS3 } from '../common/FileUploaded';

import './ListTicketKnowledge.css';
import { onHoverPopoverFootprint } from './handler/FootprintHandler';
import {
    handleClickChecked,
    handleClickShareStatus,
    handleClosePopover,
    isAddtionalViewOrEdit,
    isCheckedChangeStatusOption
} from './handler/ShareStatusKnowledgeHandler';

import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';

import Bookmark from './elements/Bookmark/Bookmark';
import TaggedBookmarkListName from './elements/Bookmark/TaggedBookmarkListName';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { downloadFileFromS3 } from '@/component/common/FileUploaded';
import { ButtonOption, FlagMessageCopyLink } from '../ticketList/DetailTicketList';
import CopyShareLinkListItem from '@/component/common/CopyShareLinkListItem';

const getCorporationByInfo = (affiliationProjectInfo, corporationDetail, ticketKnowledge) => {
    let affiliationOrganizationInfo = {};
    if (affiliationProjectInfo.affiliationOrganization === corporationDetail.id) {
        affiliationOrganizationInfo = corporationDetail;
    } else if (ticketKnowledge.affiliationOrganizationInfo) {
        affiliationOrganizationInfo = ticketKnowledge.affiliationOrganizationInfo;
    }

    return affiliationOrganizationInfo;
};

export default function ListKnowledgeItem(props) {
        let {
            corporationDetail,
            isViewDelete,
            projectInuseDetail,
            openChatThreadPanel,
            userPermissionView,
            addViewPopover,
            setFootPrintPopover,
            ticketKnowledgeList,
            setUserFootprintList,
            idPopOverFootPrint,
            openPopoverFootPrint,
            footPrintPopover,
            userFootprintList,
            argsCommon,
            addNewPanel,
            setLastUserAction,
            userDetail,
            isProjectManager,
            viewStructure,
            idPopoverShareStatus,
            setShareStatusPopover,
            setOpenShareStatusPopover,
            openShareStatusPopover,
            shareStatusPopover,
            shareStatusData,
            isShowIconPageUnit,
            setPreviousViewStructure,
            setViewStructure,
            isCustomer,
            setFileNamePdfSelect,
            setTriggerSearch,
            fileNamePdfSelect,
            corporationSelectedId,
            setIsOpenModalReloadPage,
            setIsLoading,
            handleOpenFile,
            visibilityKnowledgeAtom,
            ticketKnowledge,
            setIsShowPopupLogout,
            setOpenPreviewImage,
        } = {...props};
        const [openOption, setOpenOption] = useState(null);
        const [openFileOption, setOpenFileOption] = useState(null);
        const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);

        // Sử dụng userAtom để lấy thông tin user hiện tại
        const currentUserDetail = useRecoilValue(userAtom);
        
        const [footPrint, setFootPrint] = useState([]);
        const id = addViewPopover ? 'simple-popover' : undefined;
        let isAddtional = isAddtionalViewOrEdit(ticketKnowledge);
        let labelOfButtonShareStatus = isAddtional
            ? `${Constant.KNOWLEDGE_SHARE_STATUS_LABEL}+`
            : Constant.KNOWLEDGE_SHARE_STATUS_LABEL;
        let affiliationProjectInfo = ticketKnowledge?.affiliationProjectInfo;
        let projectName = `${Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            affiliationProjectInfo?.name
        )}`;

        useEffect(() => {
            setFootPrint(ticketKnowledge?.footPrint)
        },[ticketKnowledge.id, ticketKnowledge?.footPrint])

        // get affiliationOrganizationInfo;
        let affiliationOrganizationInfo = getCorporationByInfo(affiliationProjectInfo, corporationDetail, ticketKnowledge)
        let corporationNameSuffixText = Utils.getCorporationNameSuffixText(
            affiliationOrganizationInfo
        );

        projectName = corporationNameSuffixText ? `${projectName} (${corporationNameSuffixText})` : `${projectName}`;
        
        // creator
        let creatorName = `${Utils.getUserNameWithActiveStatus(ticketKnowledge?.creatorInfo)}`;
        let suffixCreatorName = Utils.getCorporationNameSuffixText(
            ticketKnowledge?.creatorInfo?.affiliationOrganizationInfo
        );
      
        creatorName = suffixCreatorName ? `${creatorName} (${suffixCreatorName})` : `${creatorName}`;

        // updator
        let updatorName = `${Utils.getUserNameWithActiveStatus(ticketKnowledge?.updatorInfo)}`;
        let suffixUpdatorName = Utils.getCorporationNameSuffixText(
            ticketKnowledge?.updatorInfo?.affiliationOrganizationInfo
        );

        const dataShareLink = Utils.convertJSONDataToObject(ticketKnowledge?.dataShareLink);
        const attachFiles = ticketKnowledge?.attachFiles ? Utils.convertJSONDataToObject(ticketKnowledge?.attachFiles) : [];
        
        updatorName = suffixUpdatorName ?  `${updatorName} (${suffixUpdatorName})` : `${updatorName}`;

        const getFootPrintLength = () => {
            let lengthFootPrint = 0;
            if (footPrint?.length > 0) {
                lengthFootPrint = footPrint?.length > 100 ? '99+' : `${footPrint?.length}`;
            }

            return `${lengthFootPrint}`;
        };

        const onClickToViewTicket = async () => {
            if(!footPrint.includes(userDetail.id) && userDetail.id !== ticketKnowledge.creator){
                let footPrintClone = Utils.isEmptyArray(footPrint) ? [] : [...footPrint];
                footPrintClone.push(userDetail.id);
                setFootPrint([...footPrintClone])
            };

            return viewTicketKnowledgeDetail(
                argsCommon,
                ticketKnowledge.id,
                addNewPanel,
                setLastUserAction,
                true
            );
        };

        const handleFootprintPopover = async (e) => {
            await onHoverPopoverFootprint(
                e,
                ticketKnowledge,
                setFootPrintPopover,
                ticketKnowledgeList,
                setUserFootprintList,
                footPrint, 
                currentUserDetail
            );
        };

        return (
            <div className={`knowledge-item-container ${ticketKnowledge.id}`} key={ticketKnowledge.id}>
                <div className="knowledge-frame" key={ticketKnowledge.id}>
                    <div className="knowledge-head">
                        <div className="knowledge-head-absolute-wrap">
                            <Bookmark
                                isViewDelete={isViewDelete}
                                ticketKnowledge={ticketKnowledge}
                                isShowEdit={true}
                                isShowDefaultBookmark={false}
                            />
                            <TaggedBookmarkListName
                                bookmarkListText={ticketKnowledge?.bookmarkListText}
                                className="tagged-bookmark-knowledge-list-text"
                            />
                        </div>
                        <div className="knowledge-icon-frame knowledge-icon-frame-position-updated">
                            {hasKnowledgeChatPermission(ticketKnowledge, projectInuseDetail) &&
                                ticketKnowledge.public === Constant.TICKET_PUBLIC.PUBLIC && (
                                    <Badge
                                        overlap="rectangular"
                                        badgeContent={
                                            ticketKnowledge?.totalUnreadMsg > 0
                                                ? ticketKnowledge?.totalUnreadMsg
                                                : null
                                        }
                                        color="secondary"
                                        className="knowledge-chat-icon"
                                        onClick={() => openChatThreadPanel(ticketKnowledge)}
                                    >
                                        <img src="/assets/image/icon-chat.svg" alt="" />
                                    </Badge>
                                )}
                            <CopyShareLinkListItem
                                dataShareLink={dataShareLink}
                                publicStatus={ticketKnowledge.public}
                            />

                            {ticketKnowledge.public === Constant.TICKET_PUBLIC.PUBLIC &&
                                [
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.PERSONAL_PROJECT,
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER
                                ].includes(userPermissionView?.type) &&
                                projectInuseDetail.id === ticketKnowledge?.affiliationProject && (
                                    <div className="knowledge-btn">
                                        <div className="footprints ticket-outline">
                                            <Typography
                                                className="knowledge-footprint"
                                                aria-describedby={id}
                                                variant="inherit"
                                                onClick={handleFootprintPopover}
                                            >
                                                <span className="knowledge-item">
                                                    <img
                                                        src="/assets/image/icon-footprints.svg"
                                                        alt=""
                                                        className="knowledge-icon-frame-size"
                                                    />
                                                </span>
                                                <span className="number-count">
                                                    {getFootPrintLength()}
                                                </span>
                                            </Typography>
                                            {!Utils.isEmptyArray(footPrint) && (
                                                <Popover
                                                    className="numberView-sub"
                                                    id={idPopOverFootPrint}
                                                    open={openPopoverFootPrint}
                                                    anchorEl={footPrintPopover}
                                                    onClose={e => setFootPrintPopover(null)}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center'
                                                    }}
                                                >
                                                    <div
                                                        className="listView"
                                                        id={`footprint_id_${ticketKnowledge.id}`}
                                                    >
                                                        <ul>{userFootprintList}</ul>
                                                    </div>
                                                </Popover>
                                            )}
                                        </div>
                                    </div>
                                )}

                            <div className="bookmark-count">
                                <Bookmark
                                    isViewDelete={isViewDelete}
                                    ticketKnowledge={ticketKnowledge}
                                    isShowEdit={false}
                                    isShowDefaultBookmark={true}
                                    tagDefaultBookmarkClassName={
                                        'reset-position-list-bookmark-icon'
                                    }
                                />
                                <span className="bookmark-count-number">
                                    {ticketKnowledge.totalPrivateBookmark >= 100
                                        ? '99+'
                                        : ticketKnowledge.totalPrivateBookmark}
                                </span>
                            </div>
                        </div>
                        <div className="knowledge-info">
                            <div
                                className="knowledgeTitle ticket-outline titleDisplay"
                                onClick={e => onClickToViewTicket()}
                            >
                                <Tooltip
                                    title={
                                        getTitle(ticketKnowledge?.settingTitle)
                                            ? generateDetatilTicketTitle(ticketKnowledge)
                                            : '[概要 (現在未記入)]'
                                    }
                                >
                                    <label
                                        className="titleDisplay titleTicket-titlev2 title-clamp"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {getTitle(ticketKnowledge?.settingTitle)
                                            ? generateDetatilTicketTitle(ticketKnowledge)
                                            : '[概要 (現在未記入)]'}
                                    </label>
                                </Tooltip>
                                <OverFlowTooltipWithTabsMui
                                    value={projectName}
                                    className="knowledgeTitle-proj"
                                />
                            </div>
                        </div>
                        {permissionChangeShareRangeStatus(
                            ticketKnowledge,
                            userDetail,
                            isProjectManager,
                            projectInuseDetail,
                            viewStructure
                        ) && (
                            <div className="knowledge-share-status">
                                <Typography
                                    className="knowledge-share-status-label"
                                    aria-describedby={idPopoverShareStatus}
                                    variant="inherit"
                                    onClick={e =>
                                        handleClickShareStatus(
                                            e,
                                            ticketKnowledge,
                                            setShareStatusPopover,
                                            setOpenShareStatusPopover,
                                            argsCommon
                                        )
                                    }
                                    style={{
                                        marginTop: 10
                                    }}
                                >
                                    <span>{`${labelOfButtonShareStatus}`}</span>
                                </Typography>
                                <Popover
                                    className="share-status-popover"
                                    id={idPopoverShareStatus}
                                    key={`popover-share-status-${ticketKnowledge.id}`}
                                    open={openShareStatusPopover === ticketKnowledge.id}
                                    anchorEl={shareStatusPopover}
                                    onClose={e =>
                                        handleClosePopover(
                                            e,
                                            argsCommon,
                                            ticketKnowledge,
                                            shareStatusData
                                        )
                                    }
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'right'
                                    }}
                                >
                                    <div>
                                        <div
                                            className="listView knowledge-share-status-list"
                                            id={`share_status_id_${ticketKnowledge.id}`}
                                        >
                                            <FormControl
                                                component="fieldset"
                                                id={`form-control-share-status-${ticketKnowledge.id}`}
                                            >
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li share-status-li-checked`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}-formGroup`}
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .CREATOR_ONLY
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={true}
                                                                disabled={true}
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .CREATOR_ONLY
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}`}
                                                    />
                                                </FormGroup>
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li share-status-li-checked`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}-formGroup`}
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_PROJECT
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={true}
                                                                disabled={true}
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_PROJECT
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}`}
                                                    />
                                                </FormGroup>
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li${
                                                        isCheckedChangeStatusOption(
                                                            Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                .IN_ORG,
                                                            argsCommon
                                                        )
                                                            ? ' share-status-li-checked'
                                                            : ''
                                                    }`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG}-formGroup`}
                                                    onChange={e =>
                                                        handleClickChecked(
                                                            e,
                                                            argsCommon,
                                                            Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                .IN_ORG
                                                        )
                                                    }
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_ORG
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .IN_ORG,
                                                                    argsCommon
                                                                )}
                                                                disabled={
                                                                    !Utils.isEmptyString(
                                                                        ticketKnowledge.deletedAt
                                                                    )
                                                                }
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_ORG
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG}`}
                                                    />
                                                </FormGroup>
                                                {corporationDetail.deskService ===
                                                    Constant.STATUS_SERVICE_PERMISSION.ON && (
                                                    <>
                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_CUSTOMER,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_CUSTOMER
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_CUSTOMER
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .B2B_CUSTOMER,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_CUSTOMER
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER}`}
                                                            />
                                                        </FormGroup>
                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_SUPPORT,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_SUPPORT
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_SUPPORT
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .B2B_SUPPORT,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_SUPPORT
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT}`}
                                                            />
                                                        </FormGroup>

                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .PUBLIC,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.PUBLIC}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .PUBLIC
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .PUBLIC
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .PUBLIC,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .PUBLIC
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.PUBLIC}`}
                                                            />
                                                        </FormGroup>
                                                    </>
                                                )}
                                            </FormControl>
                                            {isAddtional && (
                                                <div
                                                    className="share-status-popover-additional"
                                                    onClick={e =>
                                                        viewTicketKnowledgeDetail(
                                                            argsCommon,
                                                            ticketKnowledge.id,
                                                            addNewPanel,
                                                            setLastUserAction,
                                                            true
                                                        )
                                                    }
                                                >
                                                    <span className="share-status-item-additional">
                                                        {
                                                            Constant.KNOWLEDGE_SHARE_STATUS_LABEL_ADDITIONAL
                                                        }
                                                    </span>
                                                    <span className="share-status-item-additional">
                                                        <img
                                                            src="/assets/image/share-status-additional.svg"
                                                            alt=""
                                                        />
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        )}
                    </div>
                    <div className="knowledge-content">
                        <div className="knowledge-thumnail">
                            <ul className="thumnail-list">
                                {[
                                    ...(ticketKnowledge?.attachments?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)) || []),
                                    ...(attachFiles?.filter(
                                        i =>
                                            i?.originId?.includes(Constant.ID_PREFIX.CHAT_POST) &&
                                            ticketKnowledge?.chatPermission !== Constant.KNOWLEDGE_CHAT_PERMISSION.NO
                                    ) || [])
                                ]
                                    ?.slice(0, Constant.ATTACH_FILES_LIMIT)
                                    ?.map((file, index) => {
                                        if (
                                            attachFiles
                                                ?.filter(i => i?.originId?.includes(Constant.ID_PREFIX.CHAT_POST))
                                                ?.includes(file)
                                        ) {
                                            file.fileName = file?.fileInfo?.fileName;
                                            file.fileUrl = file?.fileInfo?.fileUrl;
                                            file.fileSize = file?.fileInfo?.fileSize;
                                        }

                                        const displayTextInFile = displayTagOfThumbAttach(
                                            ticketKnowledge,
                                            file.fileName
                                        );
                                        const isDisplayPdf = displayTextInFile.name === 'pdf';

                                        const thumbnailInfo =
                                            file?.thumbnailInfo ||
                                            attachFiles?.find(
                                                att => att?.fileInfo?.fileUrl === file.fileUrl
                                            )?.thumbnailInfo;

                                        const imgThumbnailLink = getLinkDownloadFileFromS3(
                                            {
                                                ...file,
                                                type: Constant.S3_FILE_TYPE.TICKET_FILE,
                                                thumbnailInfo: JSON.stringify(thumbnailInfo)
                                            },
                                            ticketKnowledge,
                                            null,
                                            Constant.ATTACH_FILE.VIEW_TICKET
                                        );

                                        const imgLink = getLinkDownloadFileFromS3(
                                            {
                                                ...file,
                                                type: Constant.S3_FILE_TYPE.TICKET_FILE,
                                                thumbnailInfo: null
                                            },
                                            ticketKnowledge
                                        );

                                        return (
                                            <>
                                                <Tooltip
                                                    title={file.fileName}
                                                    aria-label={file.fileName}
                                                    key={index}
                                                >
                                                    <li
                                                        className={`knowledge-attach ${
                                                            isDisplayPdf
                                                                ? 'knowledge-attach-pdf'
                                                                : ''
                                                        }`}
                                                        style={{
                                                            display: 'flex'
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                Utils.isImageFile(file.fileName)
                                                                    ? imgThumbnailLink
                                                                    : '/assets/image/others_file.png'
                                                            }
                                                            alt=""
                                                            aria-label="more"
                                                            aria-controls="long-menu"
                                                            aria-haspopup="true"
                                                            onClick={() => {
                                                                if (
                                                                    Utils.isImageFile(file.fileName)
                                                                ) {
                                                                    setOpenPreviewImage(imgLink);
                                                                } else {
                                                                    downloadFileFromS3(
                                                                        {
                                                                            content: file.fileName,
                                                                            fileSize: parseInt(
                                                                                file.fileSize
                                                                            ),
                                                                            fileUrl: file.fileUrl,
                                                                            type: 1
                                                                        },
                                                                        ticketKnowledge,
                                                                        false,
                                                                        isDisplayPdf,
                                                                        '',
                                                                        setIsShowPopupLogout
                                                                    );
                                                                }
                                                            }}
                                                            style={{ objectFit: 'cover' }}
                                                        />
                                                        <span
                                                            style={{
                                                                '--background-color-file':
                                                                    displayTextInFile.colorCode
                                                            }}
                                                        >
                                                            {displayTextInFile.name}
                                                        </span>
                                                        {ticketKnowledge &&
                                                            ticketKnowledge.public !==
                                                                Constant.TICKET_PUBLIC.DRAFT &&
                                                            Utils.isImageFile(file.fileName) && (
                                                                <div
                                                                    style={{
                                                                        height: '100%',
                                                                        backgroundColor:
                                                                            'transparent',
                                                                        width: 16,
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        flexShrink: 0
                                                                    }}
                                                                    onClick={e => {
                                                                        setOpenFileOption(
                                                                            attachFiles?.find(
                                                                                i =>
                                                                                    i.fileInfo
                                                                                        .fileUrl ===
                                                                                    file?.fileUrl
                                                                            )
                                                                        );
                                                                        setOpenOption(
                                                                            e.currentTarget
                                                                        );
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-more-panel.svg"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                    </li>
                                                </Tooltip>
                                                {isShowIconPageUnit(ticketKnowledge, file) && (
                                                    <Tooltip
                                                        title={I18n.get(
                                                            'LABEL-PAGE-KNOWLEDGE-UNIT'
                                                        )}
                                                        aria-label={I18n.get(
                                                            'LABEL-PAGE-KNOWLEDGE-UNIT'
                                                        )}
                                                        className="icon-triple-page"
                                                    >
                                                        <IconButton
                                                            onClick={async () => {
                                                                await handleSelectFilePdf(
                                                                    setPreviousViewStructure,
                                                                    setViewStructure,
                                                                    viewStructure,
                                                                    ticketKnowledge,
                                                                    file,
                                                                    isCustomer,
                                                                    setFileNamePdfSelect,
                                                                    setTriggerSearch,
                                                                    fileNamePdfSelect,
                                                                    corporationSelectedId,
                                                                    props.API,
                                                                    setIsOpenModalReloadPage,
                                                                    setIsLoading
                                                                );
                                                            }}
                                                            style={{ marginRight: 5 }}
                                                        >
                                                            <img
                                                                src="/assets/image/triple_page.svg"
                                                                alt={displayTextInFile.name}
                                                            />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </>
                                        );
                                    })}
                                {ticketKnowledge?.attachments?.length +
                                    attachFiles?.filter(
                                        i =>
                                            i?.originId?.includes('post') &&
                                            ticketKnowledge?.chatPermission !==
                                                Constant.KNOWLEDGE_CHAT_PERMISSION.NO
                                    )?.length >
                                    Constant.ATTACH_FILES_LIMIT && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                padding: '2px 5px',
                                                border: '1px solid #2D72D2',
                                                borderRadius: 8,
                                                alignItems: 'center',
                                                cursor: 'pointer'
                                            }}
                                            onClick={onClickToViewTicket}
                                        >
                                            <p
                                                style={{
                                                    color: '#2D72D2',
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                    fontFamily: 'Zen Kaku Gothic New'
                                                }}
                                            >
                                                {I18n.get('COMBTN009')}
                                            </p>
                                            <ChevronRightIcon style={{ color: '#2D72D2' }} />
                                        </div>
                                    </div>
                                )}
                            </ul>
                        </div>
                        <div className="knowledge-icon-frame">
                            {isDisplayEyeSlashIcon(
                                isCustomer,
                                visibilityKnowledgeAtom,
                                ticketKnowledge
                            ) && (
                                <div className="knowledge-btn-eye">
                                    <div className="chat">
                                        <span className="knowledge-item">
                                            <VisibilityOffIcon style={{ width: 16 }} />
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="knowledge-footer">
                        <div className="knowledge-lst">
                            <div>
                                <p className="knowledge-date">{`作成日： ${Utils.getDateByFormatYYYY_MM_DD(
                                    ticketKnowledge.createdAt
                                )}`}</p>
                                <OverFlowTooltipWithTabsMui
                                    className="knowledge-name"
                                    value={creatorName}
                                />
                            </div>
                        </div>

                        <div className="knowledge-lst">
                            <div>
                                <p className="knowledge-date">{`更新日： ${Utils.getDateByFormatYYYY_MM_DD(
                                    ticketKnowledge.updatedAt
                                )}`}</p>
                                <OverFlowTooltipWithTabsMui
                                    className="knowledge-name"
                                    value={updatorName}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <Popover
                    open={Boolean(openOption) || false}
                    anchorEl={openOption}
                    onClose={() => {
                        setOpenFileOption(null);
                        setOpenOption(null);
                    }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                    style={{ marginLeft: -10 }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        {openFileOption?.shortKey && (
                            <FlagMessageCopyLink
                                title={I18n.get('KNOWDEMSG002')}
                                placement="top-start"
                                arrow={true}
                                open={isShowFlagMessage}
                            >
                                <ButtonOption
                                    onClick={() => {
                                        const linkUrl = Utils.getShareLinkImg({
                                            attachFile: openFileOption,
                                            dataShareLink
                                        });
                                        navigator.clipboard.writeText(linkUrl);
                                        setIsShowFlagMessage(true);
                                        setTimeout(() => {
                                            setIsShowFlagMessage(false);
                                        }, 3000);
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 15,
                                            fontWeight: 400,
                                            fontFamily: 'Zen Kaku Gothic New'
                                        }}
                                    >
                                        {I18n.get('GET_URL')}
                                    </span>
                                </ButtonOption>
                            </FlagMessageCopyLink>
                        )}
                    </div>
                </Popover>
            </div>
        );
    };